export default __webpack_public_path__ + "static/media/img_post5.28b67a60.png";